import { CumulativeDate } from "types/cart/shipment-review";
import { ILineItem } from "constants/order-types";
import me from "models/me";

export const isInErrorState = (available: number | null, quantity: number, prebook: boolean = false): boolean =>
    (available === null || me.hasPermission("can_oversell") ? false : quantity > available) && !prebook;

export const getLineItemDate = (lineItem: ILineItem, cumulativeDate: CumulativeDate): string =>
    cumulativeDate === "shipStart" ? lineItem.ship_start : lineItem.ship_end;
